import VectorLayer from '@/models/vector-layer'
import vectorUtils from '@src/utils/vectorUtils'
import {LayerTypes} from '@models/layer'

export default class VectorFillLayer extends VectorLayer {
  constructor (obj, needMap) {
    super(obj, needMap)
    if (needMap) {
      this._type = LayerTypes.VECTOR_FILL
      let color = obj.color ? obj.color : vectorUtils.randomColor()
      this._paint = obj.style ? obj.style : {
        'fill-color': color,
        'fill-opacity': obj.opacity ? obj.opacity : 1,
        'fill-outline-color': obj.fillColor ? obj.fillColor : vectorUtils.randomColor()
      }
    } else {
      Object.assign(this, obj)
    }
  }

  get colorPreview () {
    if (typeof this._paint['fill-color'] === 'string') return this._paint['fill-color']
    return '#0cc45f'
  }

  get mapboxOpacityKeys () {
    return ['fill-opacity']
  }
}



// WEBPACK FOOTER //
// ./src/models/vector-fill-layer.js